import { initializeApp } from 'firebase/app';
import { getMessaging, onMessage, getToken, deleteToken } from 'firebase/messaging';
import deviceManager from "./DeviceManager";

const firebaseConfig = {
    apiKey: "AIzaSyDcsuIXjGUYi8jF-c5IcmDKo2GC2MPi9fw",
    authDomain: "routa-demo-messaging.firebaseapp.com",
    projectId: "routa-demo-messaging",
    storageBucket: "routa-demo-messaging.appspot.com",
    messagingSenderId: "568961086411",
    appId: "1:568961086411:web:06b47b65e918bcea693c4e",
    measurementId: "G-X4M925F4GP"
};

const vapidKey = 'BClR3tq-slRHWwJPirRwYt-bCufPbHahaORxos9qz-x2_RRzzBdKIkfqt_6cidBKDR8ug4AfzM0qVSM-DdVB1QI';
const firebaseApp = initializeApp(firebaseConfig);

let token;

function tryParse(json) {
    try {
        return JSON.parse(json);
    } catch (e) {
        return json;
    }
}

function parseMsg(msg) {
    const ret = msg;
    ret.data.body = tryParse(ret.data.body);
    return ret;
}

export async function register(restApi, messageHandler) {
    const msg = getMessaging(firebaseApp);
    token = await getToken(msg,{vapidKey});
    await deviceManager.register(restApi, token);
    if (messageHandler instanceof Function) {
        try {
            const bgNotification = new BroadcastChannel('bgNotification');
            bgNotification.onmessage = evt => messageHandler(parseMsg(evt.data));
            onMessage(msg,evt => messageHandler(parseMsg({...evt, action: 'fgmessage'})));
        } catch {
            // Ignore - Notifications could not be initialized (e.g. iOS)
            // eslint-disable-next-line
            console.warn('Notifications not active')
        }
    }
}

export async function unregister(restApi) {
    if (token != null) {
        try {
            await deviceManager.unregister(restApi, token);
        } catch (ex) {
            // eslint-disable-next-line
            console.error(ex)
        } finally {
            try {
                const msg = getMessaging(firebaseApp);
                await deleteToken(msg);
            } catch (e) {
                // eslint-disable-next-line
                console.error(e)
            }
        }
    }
}

/**
 * @param restApi mixin
 * @param {string} topic to send the notification to
 * @param {string} title of the notification
 * @param {string} message
 * @param {string|null} icon
 */
export async function sendNotification(restApi, topic, title, message, icon = null) {
    await new Promise((resolve, reject) =>
        restApi.restAdd(
            `${restApi.notification}/send`,
            {
                topic: topic,
                title: title,
                message: message,
                icon: icon,
            },
            resolve,
            reject
        )
    )
}
